export function usePwaFlag() {
    return window.location.href.includes("pwa=true");
}
